import * as types from '../actions/types'


const initialState = {
    loading : false,
    profile : null,
    error : null
}

const profileReducer = (state=initialState,action) =>{
    switch(action.type){
        case types.GET_USER_PROFILE_REQUEST:{
            return {
                ...state,
                loading : true
            }
        }
        case types.GET_USER_PROFILE_SUCCESS:{
            return {
                ...state,
                loading : false,
                profile : action.payload
            }
        }
        case types.GET_USER_PROFILE_FAILED :{
            return {
                ...state,
                loading : false,
                error : action.payload
            }
        }

        case types.LOGOUT : {
            return {
                loading : false,
                profile : null,
                error : null
            }
        }

        default:{
            return {
                ...state
            }
        }
    }
}


export default profileReducer